import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import FieldWrapper from '@/forms/FormElements/Common/FieldWrapper/FieldWrapper.vue';
import ErrorWrapper from '@/forms/FormElements/Common/ErrorWrapper/ErrorWrapper.vue';
import Dropdown from '@/forms/FormElements/Inputs/Dropdown/Dropdown.vue';

import RowValidationMixin from '@/forms/FormElements/Mixins/RowValidationMixin';
import DropdownModel from '@/common/interfaces/DropdownModel';
import SelectItem from '@/common/interfaces/SelectItem';

@Component({ components: { FieldWrapper, Dropdown, ErrorWrapper } })
export default class DropdownRow extends mixins(RowValidationMixin) {
  @Prop()
  readonly list!: SelectItem[];

  @Prop({ type: Boolean, default: false })
  readonly filterDuplicates!: boolean;

  @Prop({ type: String, default: '' })
  readonly placeholder!: string;
  
  @Prop()
  readonly value: number | string;

  @Prop()
  readonly multiple: boolean;

  change(value: string | number, prevValue: string | number) {
    this.$emit('change', value, prevValue);
  }
  fullOption(option) {
    this.$emit('fullOption', option)
  }
  mounted() {
    if (this.value) this.model[this.name] = String(this.value);
  }
}
